/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ExcelIcon = createIcon("ExcelIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#107C41';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.1 30 3.15-5.004L15.455 30h2.718l-4.563-6.885 4.077-6.129H15.33l-2.872 4.554-2.889-4.554h-2.7l4.221 6.39L6.724 30h2.377Zm19.36 0v-1.89h-5.878V16.986H20.37L20.358 30h8.1Zm7.361.18c3.114 0 5.086-1.593 5.086-3.636 0-1.377-.45-3.267-3.357-3.861l-2.34-.522c-1.53-.351-1.99-.837-1.99-1.683 0-1.17 1.135-1.872 2.566-1.872 1.44 0 2.591.54 2.753 2.088h2.215c-.027-2.106-1.746-3.87-4.995-3.87-2.782 0-4.86 1.539-4.843 3.897.027 1.899 1.216 3.033 3.16 3.429l2.393.522c1.332.288 2.224.819 2.224 1.89 0 1.206-1.27 1.863-2.88 1.863-1.522 0-2.727-.711-3.016-2.025H30.53c.296 2.511 2.762 3.78 5.291 3.78Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.ExcelIcon",
  "replaceColor": true
});